import { useMutation } from '@tanstack/react-query';
import Config from 'src/common/Config';

const API_URL = Config.getApiUrl();

type Payload = {
  familyId?: string;
  advisorUserId?: string;
  advised?: boolean;
};

export function useUpdateClient() {
  const { mutateAsync, error, isLoading, reset } = useMutation({
    mutationFn: async ({ id, values }: { id: string; values: Payload }) => {
      const response = await fetch(`${API_URL}/clients/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(values),
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (response.status < 200 || response.status > 299) throw response;

      const data = await response.json();
      return data;
    },
  });

  const updateClient = async (id: string, values: Payload) => {
    return mutateAsync({ id, values });
  };

  return {
    updateClient,
    error,
    isLoading,
    reset,
  };
}
